import styled from 'styled-components';
import { outlineGray, primaryColorLight, primaryColorWeak, textGrey } from '../../../../config/colors';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  font-size: 0.8125rem;
  .table-scoring {
    table-layout: auto;
    width: 100%;
    border-spacing: 0;

    .th-scoring {
      background-color: whiteSmoke;
    }

    .th-scoring,
    .td-scoring {
      margin: 0;
      padding: 0.5rem;
      border: 2px solid white;
      border-left: 0;
      text-align: center;
      :first-child {
        border-left: 2px solid white;
      }
    }
    .tbody-scoring {
      .th-scoring {
        vertical-align: baseline;
      }
      .td-scoring {
        height: 3.5rem;
        :last-of-type {
          padding: 0;
          svg {
            transition: transform 0.2s linear;
          }
        }
      }
    }
  }
  .tfoot-scoring,
  .td-scoring {
    background-color: ${primaryColorWeak};
  }
  .hide {
    display: none;
  }
  .td-expanded-scoring {
    padding: 0;
    > div {
      width: calc(100% - 7rem);
      margin: auto;
    }
  }
  .tr-total-expanded-scoring {
    > :first-child {
      opacity: 0;
      padding: 0;
    }
  }

  .td-total-expanded-scoring {
    padding: 0;
    padding-left: 0;
    > div {
      width: calc(100% - 7rem);
      margin: auto;
    }
  }
`;
